import React, { memo } from 'react';
import SpaceItem, { Space } from '../common/SpaceItem';

interface StarredSpaceItemProps {
  space: Space;
  onUnstar: (id: string) => void;
}

const StarredSpaceItem = ({ space, onUnstar }: StarredSpaceItemProps) => {
  return <SpaceItem space={space} isStarred onStarToggle={onUnstar} />;
};

export default memo(StarredSpaceItem);
